// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Box, Button, Center, Loader, Text } from '@mantine/core';
import { i18n } from '@lingui/core';
import { closeAllModals } from '@mantine/modals';
import { FC, useState } from 'react';
import { CalDavS } from '../../../Service/CalDavS';

const DeleteCalendarModal: FC<{ calendarId: string; removeCalendar: () => void }> = ({
  calendarId,
  removeCalendar,
}) => {
  const [loading, setLoading] = useState(false);

  const onConfirm = () => {
    setLoading(true);
    CalDavS.removeCalendar(calendarId)
      .then((deleted) => {
        if (deleted) {
          removeCalendar();
          closeAllModals();
        }
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Text mt="xl">{i18n._('externalSubscription.delete.confirm')}</Text>
      <Center>
        <Box sx={{ width: '70%' }}>
          <Button
            fullWidth
            mt="xl"
            mb="xs"
            onClick={onConfirm}
            disabled={loading}
            leftIcon={loading && <Loader size="xs" />}
          >
            {i18n._('actions.yes')}
          </Button>
          <Button fullWidth disabled={loading} color="gray" variant="subtle" onClick={() => closeAllModals()}>
            {i18n._('actions.cancel')}
          </Button>
        </Box>
      </Center>
    </>
  );
};

export default DeleteCalendarModal;
